import type {
    ReactiveFormSupportDataPhase,
    ReactiveFormSupportDataSource,
} from '@fitogest/reactive-form-builder/interfaces';
import type { TratamientosModel } from 'src/app/models/tratamientos/tratamientos.model';

export const TRATAMIENTOS_FORM_SUPPORT_DATA_KEYS = {
    clientes: 'clientes',
    productos: 'productos',
    agentes: 'agentes',
    unidadesMedida: 'unidadesMedida',
} as const;

export type TratamientosFormSupportDataKey =
    typeof TRATAMIENTOS_FORM_SUPPORT_DATA_KEYS[keyof typeof TRATAMIENTOS_FORM_SUPPORT_DATA_KEYS];

export interface TratamientosFormLoadPlanOptions {
    readonly formType: number;
    readonly shouldLoadDistinctAgentes: boolean;
    readonly showUnidadesMedidaSIEX: boolean;
    readonly isClientFieldVisible: boolean;
}

/** Defines support-data phases for the Tratamientos reactive form. */
export class TratamientosFormLoadPlan {
    public static createSupportDataSources(
        options: TratamientosFormLoadPlanOptions,
    ): readonly ReactiveFormSupportDataSource<TratamientosModel>[] {
        const sources: ReactiveFormSupportDataSource<TratamientosModel>[] = [
            TratamientosFormLoadPlan.createSource(TRATAMIENTOS_FORM_SUPPORT_DATA_KEYS.productos, 'critical'),
            TratamientosFormLoadPlan.createSource(
                TRATAMIENTOS_FORM_SUPPORT_DATA_KEYS.clientes,
                options.isClientFieldVisible ? 'critical' : 'deferred',
            ),
            TratamientosFormLoadPlan.createSource(
                TRATAMIENTOS_FORM_SUPPORT_DATA_KEYS.unidadesMedida,
                options.showUnidadesMedidaSIEX ? 'critical' : 'deferred',
            ),
        ];

        if (options.shouldLoadDistinctAgentes) {
            sources.push(TratamientosFormLoadPlan.createSource(TRATAMIENTOS_FORM_SUPPORT_DATA_KEYS.agentes, 'critical'));
        }

        return sources;
    }

    private static createSource(
        key: TratamientosFormSupportDataKey,
        phase: ReactiveFormSupportDataPhase,
    ): ReactiveFormSupportDataSource<TratamientosModel> {
        return {
            key,
            phase,
            load: () => undefined,
        };
    }
}
